import { Table } from "antd";
import { ActionHistoryItem } from "../../model/types/integration-card";
import "./action-history-table.scss";

interface ActionHistoryTableProps {
  data: ActionHistoryItem[];
}

const COLUMN_GAP_CLASS = "action-history-table__col-gap";

const parseDateTime = (dateTime: string) => {
  const match = dateTime.match(/^(\d{2}\.\d{2}\.\d{4})\s+(\d{2}:\d{2})\s+(.+)$/);

  if (!match) {
    return { date: dateTime, time: "", timezone: "" };
  }

  return {
    date: match[1],
    time: match[2],
    timezone: match[3],
  };
};

const renderDateTime = (dateTime: string) => {
  const { date, time, timezone } = parseDateTime(dateTime);

  return (
    <div className="action-history-table__date-time">
      <span className="action-history-table__date">{date}</span>
      {time && <span className="action-history-table__time">{time}</span>}
      {timezone && (
        <span className="action-history-table__timezone">{timezone}</span>
      )}
    </div>
  );
};

const withColumnGap = {
  onHeaderCell: () => ({ className: COLUMN_GAP_CLASS }),
  onCell: () => ({ className: COLUMN_GAP_CLASS }),
};

export const ActionHistoryTable = ({ data }: ActionHistoryTableProps) => {
  const columns = [
    {
      title: "Дата, время",
      dataIndex: "dateTime",
      key: "dateTime",
      width: 162,
      ...withColumnGap,
      render: (dateTime: string) => renderDateTime(dateTime),
    },
    {
      title: "Пользователь",
      dataIndex: "user",
      key: "user",
      width: 144,
      ...withColumnGap,
      render: (user: string, record: ActionHistoryItem) => (
        <div className="action-history-table__user">
          <span className="action-history-table__user-name">{user}</span>
          {record.position && (
            <span className="action-history-table__user-position">
              {record.position}
            </span>
          )}
        </div>
      ),
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
      width: 154,
      ...withColumnGap,
      render: (status: string) => (
        <span className="action-history-table__status">{status}</span>
      ),
    },
    {
      title: "Орган Надзора",
      dataIndex: "organName",
      key: "organName",
      render: (organName: string) => (
        <span className="action-history-table__organ">{organName}</span>
      ),
    },
  ];

  return (
    <div className="action-history-table">
      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        pagination={false}
        size="small"
        tableLayout="fixed"
      />
    </div>
  );
};
